import React from "react"
import { Routes, Route, Link, NavLink } from "react-router-dom";
import Edificios from "../icons/edificios.svg";
import ProveedorIcon from "../icons/proveedor.svg";
import AlertaIcon from "../icons/alerta.svg";
import Inicio from "./pages/tec/Inicio";
import AAFF from "./pages/tec/AAFF";
import AAFFComunidades from "./pages/tec/AAFFComunidades";
import Comunidades from "./pages/tec/Comunidades";
import HojaVisita from "./pages/tec/HojaVisita";
import HojaVisitaCentroTrabajo from "./pages/tec/HojaVisitaCentroTrabajo";
import ProveedoresLista from "./pages/tec/ProveedoresLista";
import Proveedor from "./pages/tec/Proveedor";
import Alertas from "./pages/tec/alertas";


export function RouteBundle() {
  return (
    <Routes>
      <Route path="/" element={<AAFF />} />
      <Route path="/aaff" element={<AAFF />} />
      <Route path="/aaff/:nif/comunidades" element={<AAFFComunidades />} />
      <Route path="/comunidades" element={<Comunidades />} />
      <Route path="/comunidades/:nif" element={<HojaVisita />} />
      <Route path="/comunidades/:nif/:centroTrabajo" element={<HojaVisitaCentroTrabajo />} />
      <Route path="/alertas" element={<Alertas />} />
      <Route path="/proveedores" element={<ProveedoresLista />} />
      <Route path="/proveedores/:nifProveedor" element={<Proveedor />} />
    </Routes>
  )
}

export function MenuLinks() {
  return (
    <>
      <NavLink to="/aaff">
        <div className="menuBtn">
          <div className="menuItem">
            <img src={Edificios} alt="Administradores de Fincas" />
            <span>Administradores de Fincas</span>
          </div>
        </div>
      </NavLink>
      <NavLink to="/comunidades">
        <div className="menuBtn">
          <div className="menuItem">
            <img src={Edificios} alt="Comunidades" />
            <span>Comunidades</span>
          </div>
        </div>
      </NavLink>
      <NavLink to="/alertas">
        <div className="menuBtn">
          <div className="menuItem">
            <img src={AlertaIcon} alt="alertas" />
            <span>Alertas Proveedores</span>
          </div>
        </div>
      </NavLink>
      <NavLink to="/proveedores">
        <div className="menuBtn">
          <div className="menuItem">
            <img src={ProveedorIcon} alt="Proveedores" />
            <span>Proveedores</span>
          </div>
        </div>
      </NavLink>
    </>
  )
}